export default "__VITE_ASSET__oK3N_KcT__"